import AccountSettings from './AccountSettings/AccountSettings';
import SsoConfiguration from './SSOConfiguration/SSOConfiguration';
import IntegrationsPage from './Integrations/IntegrationsPage';
import IntegrationPage from './Integrations/IntegrationPage';
import AccountListingPage from './Accounts/AccountListingPage';
import AccountDetailsPage from './Accounts/AccountDetailsPage';
import Verification from './Verification/Verification';
import Logout from './Logout/Logout';
import AdvancedHrSettingsPage from './AdvancedHrSettings/AdvancedHrSettingsPage';
import AsureIdPage from './AsureId/AsureIdPage';
import AsureIdCallbackPage from './AsureId/AsureIdCallbackPage';
import AsureIdLogoutPage from './AsureId/AsureIdLogoutPage';
import SilentRenewPage from './SilentRenewPage';

const Views = {
  AccountSettings,
  SsoConfiguration,
  IntegrationsPage,
  IntegrationPage,
  AccountListingPage,
  AccountDetailsPage,
  Verification,
  Logout,
  AdvancedHrSettingsPage,
  AsureIdPage,
  AsureIdCallbackPage,
  AsureIdLogoutPage,
  SilentRenewPage,
};

export default Views;
